import styles from "../styles/servicesSection.module.css";

const Services = ({ allServices, services, dayId, timingIndex, setData }) => {
  const handleClick = (currentService) => {
    if (services.find((e) => e._id === currentService?._id)) {
      setData((prev) =>
        prev.map((obj) => {
          if (obj._id === dayId) {
            return {
              ...obj,
              timing: obj.timing.map((slot, idxx) => {
                if (timingIndex === idxx) {
                  return {
                    ...slot,
                    services: slot.services.filter((serv) => {
                      return currentService?._id !== serv._id;
                    }),
                  };
                }
                return slot;
              }),
            };
          }
          return obj;
        })
      );
    } else {
      setData((prev) =>
        prev.map((obj) => {
          if (obj._id === dayId) {
            return {
              ...obj,
              timing: obj.timing.map((slot, idxx) => {
                if (timingIndex === idxx) {
                  return {
                    ...slot,
                    services: [
                      ...slot.services,
                      {
                        _id: currentService._id,
                        status: true,
                        id: currentService._id,
                      },
                    ],
                  };
                }
                return slot;
              }),
            };
          }
          return obj;
        })
      );
    }
  };

  return (
    <div className={styles.container}>
      {allServices?.map((i) => (
        <div
          key={i._id}
          className={`${styles.item} ${
            services.find((j) => j._id === i?._id) ? styles.active : ""
          }`}
          onClick={() => handleClick(i)}
        >
          <p>{i.name}</p>
        </div>
      ))}
    </div>
  );
};

export default Services;
